<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <resourse-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import ResourseTable from "./components/ResourseTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    ResourseTable,
    // ProjectsTable,
  },
};
</script>
